<template>
  <modal
    :show.sync="showModal"
    header-classes="justify-content-center"
    :disable-background-close="true"
    @close="handleClose"
  >
    <h4 slot="header" class="title title-up">
      Add to Depth Chart
    </h4>
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>
    <el-row>
      <label class="col-md-4 col-form-label" />
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="newDepthChartPerson"
        placeholder="Select person..."
      >
        <el-option
          v-for="item in addablePeople"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-row>
    <el-row>
      <collapse
        ref="childCollapseComponent"
        v-show="!newDepthChartPerson"
      >
        <collapseItem
          title="Don't see who you're looking for?"
          class="bold-collapse-title"
          :show-caret="false"
        >
          <newPersonForm
            ref="childFormComponent"
            :is-embedded-in-modal="true"
            @savedPerson="captureSavedPerson($event)"
          />
        </collapseItem>
      </collapse>
    </el-row>
    <br>
    <el-row v-show="newDepthChartPerson">
      <label class="col-md-4 col-form-label">Depth Chart Column</label>
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="depthChartColumnId"
        placeholder="Select Depth Chart Column..."
      >
        <el-option
          v-for="item in depthChartColumns"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-row>

    <p v-if="validationError === true" style="color: red;">
      A person is required.
    </p>
    <br><br>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Add
      </p-button>
      <p-button type="danger" v-if="saving">
        Adding...
      </p-button>
          &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import Modal from '../UIComponents/Modal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';
import newPersonForm from '../People/NewUserForm';
import collapse from '../UIComponents/Collapse/Collapse';
import collapseItem from '../UIComponents/Collapse/CollapseItem';

const DepthChartsRepository = RepositoryFactory.get('depthCharts');

function validateForm(newDepthChartPerson) {
    return !!newDepthChartPerson;
}

export default {
    name: 'AddDepthChartModal',
    components: {
        Modal,
        collapse,
        collapseItem,
        newPersonForm
    },
    data() {
        return {
            showModal: false,
            material: '',
            validationError: false,
            addablePeople: [],
            newDepthChartPerson: '',
            error: '',
            saving: false,
            depthChartColumns: [
                { id: 1, name: 'New Contacts' },
                { id: 2, name: 'Meaningful Contacts' },
                { id: 3, name: 'Bible Study Participants' },
                { id: 4, name: 'Growing Disciples' },
                { id: 5, name: 'Commissioned Disciples' },
                { id: 6, name: 'Bible Study Leaders' },
                { id: 7, name: 'Disciple Makers' }
            ],
            depthChartColumnId: 1
        };
    },
    computed: {

    },
    methods: {
        handleCheck() {
            if (this.isDiscipler === true) {
                this.newDepthChartPerson = '';
            }
        },
        captureSavedPerson(event) {
            this.$message(`Successfully saved ${event.name} as a contact.`);
            this.getAddableDepthChartList();
            this.newDepthChartPerson = event;
            this.$refs.childFormComponent.clearInputs();
            this.$refs.childCollapseComponent.deactivateAll();
        },
        handleSave() {
            this.saving = true;
            if (!validateForm(this.newDepthChartPerson)) {
                this.validationError = true;
                this.saving = false;
                return;
            }

            const newDepthChartPersonId = Number.isInteger(this.newDepthChartPerson)
            // case when person is newly created, in which case an object of
            // { id, name } must be passed to display their name as the option label
                ? this.newDepthChartPerson
            // case when person is selected from addablePeople
                : this.newDepthChartPerson.id;

            DepthChartsRepository.addDepthChart(newDepthChartPersonId, this.depthChartColumnId)
                .then((response) => {
                    this.saving = false;
                    this.$emit('depthChartChange');
                    this.$emit('save');
                    this.$message(response.data.message);
                })
                .catch((error) => {
                    this.saving = false;
                    this.$message(error.response.data.message);
                });

            this.$emit('close');

            this.newDepthChartPerson = '';
            this.depthChartColumnId = 1;
            this.validationError = false;
        },
        handleClose() {
            this.newDepthChartPerson = '';
            this.depthChartColumnId = 1;
            this.validationError = false;
            this.$refs.childFormComponent.clearInputs();
            this.$refs.childCollapseComponent.deactivateAll();
            this.$emit('close');
        },
        getAddableDepthChartList() {
            DepthChartsRepository.getAddableDepthChartList()
                .then((response) => {
                    this.addablePeople = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getAddableDepthChartList();
            }
        }
    },
    created() {
        this.getAddableDepthChartList();
    },

};
</script>
